import { Component, OnInit } from '@angular/core';
import { InspectionService } from 'src/app/services/inspection/inspection.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-inspectionlist',
  templateUrl: './inspectionlist.component.html',
  styleUrls: ['./inspectionlist.component.css']
})
export class InspectionlistComponent implements OnInit {
data:any;
  constructor(private inspectionservice:InspectionService, private router:Router,
    private route:ActivatedRoute) { }

  ngOnInit() {
    this.getInspectionList();
  }
  getInspectionList() {
    debugger;
    this.inspectionservice.GetInspectList().subscribe(
      data=>{
        this.data=data;
        console.log(data);
      }
    )

    
  }
  searchmdlList(form:NgForm){

  }
}
